import Home from '@/components/Home'
import ClientSelection from '@/components/Views/ClientSelection'
import Configurations from '@/components/Views/Configurations'
import EditConfiguration from '@/components/Views/EditConfiguration'
import Payments from '@/components/Views/PaymentsSidePanel'
import Search from '@/components/Views/Search'
import Settings from '@/components/Views/Settings'
import Login from '@/login/Login'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import Vue from 'vue'
import Router from 'vue-router'
import AlternativePayments from '../components/Views/AlternativePayments'
import EditAlternativePayment from '../components/Views/EditAlternativePayment'
import AmplifyStore from '../store/index'

Vue.use(Router)

let user

getUser()

AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    user = null
    AmplifyStore.commit('auth/setUser', user)
    router.push({ path: '/auth' })
  } else if (state === 'signedIn') {
    user = await getUser()
    router.push({ path: '/' })
  }
})

function getUser() {
  return Auth.currentAuthenticatedUser().then(async (data) => {
    if (data && data.signInUserSession) {
      AmplifyStore.dispatch('auth/setAuthState', 'authenticated')
      AmplifyStore.dispatch('auth/setAuthUser', data)
      await AmplifyStore.dispatch('auth/setUserToken', data)
      return data
    }
  }).catch(err => {
    if (err !== 'User not authenticated') console.error('Error catched from currentAuthenticatedUser', err)
  })
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments,
      meta: { requiresAuth: true },
      children: [
        {
          // ClientSelection will be rendered inside User's <router-view>
          // when /payments/client-selection is matched
          path: 'client-selection',
          name: 'client',
          component: ClientSelection,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            AmplifyStore.dispatch('client/setSelectedClientAction', { text: 'Select a Publisher' })
            next()
          }
        },
        {
          path: 'settings',
          name: 'settings',
          component: Settings,
          meta: { requiresAuth: true }
        },
        {
          path: 'search/:searchValue',
          name: 'search',
          component: Search,
          meta: { requiresAuth: true }
        },
        {
          // Configurations will be rendered inside User's <router-view>
          // when /payments/configuration/:clientcode is matched
          path: 'configuration/:clientId/alternativePayments',
          name: 'alternativePayments',
          component: AlternativePayments,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if (!(to.params.clientId && to.params.clientId !== '')) {
              next(false)
            } else {
              next()
            }
          }
        },
        {
          // Configurations will be rendered inside User's <router-view>
          // when /payments/configuration/:clientcode is matched
          path: 'configuration/:clientId/alternativePayments/:paymentId',
          name: 'editAlternativePayment',
          component: EditAlternativePayment,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if (!(to.params.paymentId && to.params.paymentId !== '')) {
              next(false)
            } else {
              next()
            }
          }
        },
        {
          // Configurations will be rendered inside User's <router-view>
          // when /payments/configuration/:clientcode is matched
          path: 'configuration/:clientId',
          name: 'configuration',
          component: Configurations,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if (to.params.clientName) {
              AmplifyStore.dispatch('client/setSelectedClientAction', { text: to.params.clientName })
            }
            if (!(to.params.clientId && to.params.clientId !== '')) {
              next(false)
            } else {
              next()
            }
          }
        },
        {
          // Configurations will be rendered inside User's <router-view>
          path: 'currentconfiguration',
          name: 'currentconfiguration',
          component: Configurations,
          meta: { requiresAuth: true }
        },
        {
          // Configurations will be rendered inside User's <router-view>
          // when /payments/configuration/:id is matched
          path: 'configuration/:clientId/edit/:id',
          name: 'editConfiguration',
          component: EditConfiguration,
          meta: { requiresAuth: true },
          beforeEnter: (to, from, next) => {
            if (!to.params.clientId && to.params.id === '') {
              next(false)
            } else {
              next()
            }
          }
        }
      ]
    }
  ]
})

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser()
    if (!user) {
      return next({
        path: '/login'
      })
    } else {
    }
    return next()
  }
  return next()
})

export default router
